import type React from 'react';

import { Chip as MuiChip } from '@material-ui/core';
import type { ChipProps as MuiChipProps } from '@material-ui/core/Chip';
import { withStyles } from '@material-ui/core/styles';

import { CloseIcon } from '../icons';

import { colors, fonts } from '../styles';

export interface ChipProps extends MuiChipProps {
  active?: boolean;
}

/**
 * @deprecated This component is deprecated and will be removed in the future.
 * @description Now use '@cobliteam/ui/components/*' components.
 */
const StyledChip = withStyles({
  root: {
    color: colors.gray.dark,
    borderColor: colors.gray.light,
    backgroundColor: colors.white,
    height: 'auto',
    maxWidth: '100%',

    '&.active': {
      color: colors.primary.default,
      borderColor: colors.primary.default,
      backgroundColor: colors.shadows.getShadow(colors.primary.default, 0.1),
    },
  },
  disabled: {
    color: colors.gray.default,
    borderColor: colors.gray.light,
    backgroundColor: colors.gray.lightest,

    '&&': {
      opacity: 1,
    },
  },
  label: {
    fontWeight: fonts.weight.medium,
    fontSize: fonts.size.smallest,
    lineHeight: '17px',
    padding: '4px 15px 3px',
    display: 'inline-block',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  deletable: {
    '&&': {
      '&:focus': {
        backgroundColor: colors.white,
      },
    },
  },
  deleteIcon: {
    width: 12,
    height: 12,
    color: colors.gray.default,

    '&:hover': {
      color: colors.gray.dark,
    },

    '&&': {
      margin: '0 15px 0 -10px',
    },
  },
  clickable: {
    '&&': {
      '&:focus': {
        color: colors.gray.dark,
        borderColor: colors.gray.light,
        backgroundColor: colors.white,
      },
      '&:hover': {
        color: colors.primary.default,
        borderColor: colors.primary.default,
        backgroundColor: colors.white,
      },
      '&.active': {
        boxShadow: 'none',
        color: colors.primary.default,
        borderColor: colors.primary.default,
        backgroundColor: colors.shadows.getShadow(colors.primary.default, 0.1),
      },
    },
  },
})(MuiChip);

export const Chip: React.FC<ChipProps> = ({ active, disabled, className, onClick, onDelete, deleteIcon, ...otherProps }) => {
  const activeClass = active ? 'active' : '';
  const onClickFn = disabled ? undefined : onClick;
  const onDeleteFn = disabled ? undefined : onDelete;

  return (
    <StyledChip
      variant='outlined'
      disabled={disabled}
      className={`${className || ''} ${activeClass}`}
      deleteIcon={deleteIcon || <CloseIcon />}
      onClick={onClickFn}
      onDelete={onDeleteFn}
      {...otherProps}
    />
  );
};
